'use strict';

var MAX_FRIENDLY_MESSAGE_LENGTH = 180;
var MAX_DETAILED_MESSAGE_LENGTH = 500;

var ERROR_RULES = [
    {
        pattern: /lỗi ocr đọc chữ thumbnail/i,
        message: 'Lỗi OCR: không đọc được chữ trên thumbnail gốc (Google AI lỗi hoặc quá thời gian chờ). Vui lòng thử lại.'
    },
    {
        // The nested AI error may contain "timeout"; match the real cause first.
        pattern: /không thể dùng thumbnail làm ảnh nền/i,
        message: 'AI không tạo được thumbnail để làm ảnh nền (có thể do quá thời gian chờ). Vui lòng thử lại hoặc tắt tùy chọn dùng Thumbnail làm ảnh nền.'
    },
    {
        pattern: /(?:CAPCUT_PRO_FEATURES_REQUIRED|project capcut.*(?:tài nguyên|hiệu ứng).*pro|pro features)/i,
        message: 'Capcut bị mất Pro, Vui lòng báo cho Admin để xử lý.'
    },
    {
        // Proshow logs its configured timeout even when the real failure is that
        // CapCut never opened the export-settings screen. Match that first.
        pattern: /(?:không thể bắt đầu export capcut|configure export failed)/i,
        message: 'Không thể mở màn hình Export của CapCut. Vui lòng kiểm tra project CapCut và thử lại.'
    },
    {
        // "timeout: 30 minutes" in Proshow's diagnostic output is a configured
        // limit, not necessarily the cause. Match the nested SRT/CapCut error first.
        pattern: /(?:file subtitle srt kh[oô]ng h[ơo]p l[ệe]|project_add_subtitle_to_data_content|cannot read properties of undefined \(reading ['"]split['"]\))/i,
        message: 'File subtitle SRT bị lỗi định dạng hoặc thiếu mốc thời gian. Hãy kiểm tra từng mục theo dạng 00:00:00,000 --> 00:00:00,000.'
    },
    {
        pattern: /(?:no space left on device|disk (?:is )?full|enospc)/i,
        message: 'Máy chủ render đã hết dung lượng lưu trữ. Vui lòng liên hệ quản trị viên.'
    },
    {
        pattern: /(?:cannot allocate memory|out of memory|heap out of memory|\benomem\b)/i,
        message: 'Máy chủ render không đủ bộ nhớ. Vui lòng thử lại sau.'
    },
    {
        pattern: /(?:permission denied|access is denied|\beacces\b|\beperm\b)/i,
        message: 'Máy chủ không có quyền truy cập một file cần thiết để render.'
    },
    {
        pattern: /(?:timed?\s*out|\betimedout\b|socket hang up)/i,
        message: 'Kết nối tới dịch vụ xử lý đã hết thời gian chờ. Vui lòng thử lại.'
    },
    {
        pattern: /(?:\beconnreset\b|\beconnrefused\b|\benotfound\b|\beai_again\b|network error)/i,
        message: 'Không thể kết nối tới dịch vụ xử lý. Vui lòng kiểm tra mạng và thử lại.'
    },
    {
        pattern: /(?:too many requests|rate limit|status(?: code)?\s*429|quota (?:has been )?exceeded)/i,
        message: 'Dịch vụ xử lý đang quá tải hoặc đã hết hạn mức. Vui lòng thử lại sau.'
    },
    {
        pattern: /(?:http error 401|http error 403|status(?: code)?\s*(?:401|403)|unauthorized|forbidden)/i,
        message: 'Không có quyền truy cập file hoặc dịch vụ cần thiết để render.'
    },
    {
        pattern: /(?:video unavailable|this video is private|private video|copyright claim|copyright restriction)/i,
        message: 'Video nguồn không khả dụng, đang ở chế độ riêng tư hoặc bị giới hạn bản quyền.'
    },
    {
        pattern: /(?:sign in to confirm|confirm you(?:’|')?re not a bot|cookies.*required)/i,
        message: 'Không thể tải video nguồn vì YouTube yêu cầu xác thực lại.'
    },
    {
        pattern: /(?:requested format is not available|no video formats found)/i,
        message: 'Video nguồn không có định dạng phù hợp để tải và render.'
    },
    {
        pattern: /(?:invalid data found when processing input|moov atom not found|could not find codec parameters|error opening input|failed to read frame|end of file)/i,
        message: 'File đầu vào bị hỏng hoặc không đúng định dạng.'
    },
    {
        pattern: /(?:cannot find ffmpeg|ffmpeg.*not (?:found|installed)|spawn ffmpeg.*enoent)/i,
        message: 'Máy chủ chưa cài đặt hoặc không tìm thấy FFmpeg. Vui lòng liên hệ quản trị viên.'
    },
    {
        pattern: /(?:no such file or directory|file not found|\benoent\b)/i,
        message: 'Không tìm thấy file đầu vào cần thiết để render.'
    },
    {
        pattern: /(?:unknown encoder|encoder .* not found|decoder .* not found|unsupported codec|codec not currently supported)/i,
        message: 'Định dạng hoặc codec của file chưa được hỗ trợ.'
    },
    {
        pattern: /(?:width not divisible by 2|height not divisible by 2|invalid (?:width|height)|picture size .* is invalid)/i,
        message: 'Kích thước video không hợp lệ. Chiều rộng và chiều cao cần là số chẵn.'
    },
    {
        pattern: /(?:error initializing (?:complex )?filters|error reinitializing filters|failed to configure output pad|no such filter|invalid argument.*filter)/i,
        message: 'Hiệu ứng hoặc cấu hình render không tương thích với file đầu vào.'
    },
    {
        pattern: /(?:output file is empty|nothing was written into output file|does not contain any stream)/i,
        message: 'Không tạo được video đầu ra vì file nguồn không có dữ liệu hình ảnh hoặc âm thanh hợp lệ.'
    }
];

function readErrorMessage(error) {
    if (error === null || typeof error === 'undefined') return '';
    if (typeof error === 'string') return error;
    if (error.message) return String(error.message);
    if (error.response && error.response.data) {
        if (error.response.data.message) return String(error.response.data.message);
        if (error.response.data.error) return String(error.response.data.error);
    }
    try {
        return String(error);
    } catch (stringifyError) {
        return '';
    }
}

function cleanMessage(message) {
    return String(message || '')
        .replace(/\x1B\[[0-?]*[ -\/]*[@-~]/g, '')
        .replace(/\u0000/g, '')
        .replace(/^(?:(?:error|exception|system\.exception)\s*:?\s*)+/i, '')
        .replace(/^(?:lỗi\s*)+(?:render\s*)?:?\s*/i, '')
        .replace(/\s+/g, ' ')
        .trim();
}

function fallbackForTechnicalError(message) {
    if (/(?:voice|audio|âm thanh|giọng đọc)/i.test(message)) {
        return 'Không thể xử lý âm thanh. Vui lòng kiểm tra file âm thanh hoặc giọng đọc đã chọn.';
    }
    if (/(?:subtitle|phụ đề|caption)/i.test(message)) {
        return 'Không thể xử lý phụ đề. Vui lòng kiểm tra nội dung và thời gian của phụ đề.';
    }
    if (/(?:download|tải video|tải file|youtube|facebook|tiktok)/i.test(message)) {
        return 'Không thể tải file nguồn. Vui lòng kiểm tra đường dẫn và quyền truy cập.';
    }
    if (/(?:upload|storage|s3|google cloud|digitalocean)/i.test(message)) {
        return 'Không thể tải video hoàn thành lên kho lưu trữ. Vui lòng thử lại.';
    }
    if (/(?:capcut|proshow)/i.test(message)) {
        return 'Không thể xử lý project CapCut/ProShow. Vui lòng kiểm tra project và thử lại.';
    }
    if (/(?:thumbnail|image|ảnh)/i.test(message)) {
        return 'Không thể xử lý hình ảnh. Vui lòng kiểm tra file ảnh đầu vào.';
    }
    return 'Không thể hoàn tất render. Vui lòng kiểm tra dữ liệu đầu vào và thử lại.';
}

function isTechnicalMessage(message) {
    return /(?:ffmpeg|ffprobe|fluent-ffmpeg|command failed|exited with code|stack trace|\bat\s+[^\s]+\s*\(|typeerror|referenceerror|node:internal|\[[a-z0-9_-]+\]\s*error)/i.test(message);
}

function truncateFriendlyMessage(message) {
    if (message.length <= MAX_FRIENDLY_MESSAGE_LENGTH) return message;
    var shortened = message.slice(0, MAX_FRIENDLY_MESSAGE_LENGTH - 1);
    var lastSpace = shortened.lastIndexOf(' ');
    if (lastSpace > 100) shortened = shortened.slice(0, lastSpace);
    return shortened.replace(/[,:;.!?\s]+$/, '') + '…';
}

function truncateDetailedMessage(message) {
    if (message.length <= MAX_DETAILED_MESSAGE_LENGTH) return message;
    return message.slice(0, MAX_DETAILED_MESSAGE_LENGTH - 1).replace(/[,:;.!?\s]+$/, '') + '…';
}

function getUserFriendlyRenderError(error) {
    var rawMessage = readErrorMessage(error);
    var cleanedMessage = cleanMessage(rawMessage);
    var detail = '';
    var subtitleValidationMatch = rawMessage.match(/File subtitle SRT [^\r\n]*/i);

    // Video Reup đã ghép lỗi tải tại máy render và lỗi fallback cookie/server
    // chính vào cùng một message. Giữ nguyên chi tiết này, không đổi 403 thành
    // thông báo quyền truy cập file chung chung.
    if (/không tải được audio youtube/i.test(cleanedMessage)) {
        return 'Lỗi render: ' + truncateDetailedMessage(cleanedMessage);
    }

    // Keep the parser's location/reason (for example, "mục 12") instead of
    // hiding it behind a generic timeout message.
    if (subtitleValidationMatch) {
        return 'Lỗi render: ' + truncateFriendlyMessage(subtitleValidationMatch[0]);
    }

    for (var index = 0; index < ERROR_RULES.length; index += 1) {
        if (ERROR_RULES[index].pattern.test(rawMessage)) {
            detail = ERROR_RULES[index].message;
            break;
        }
    }

    if (!detail) {
        if (!cleanedMessage) {
            detail = 'Không thể hoàn tất render. Vui lòng thử lại.';
        } else if (isTechnicalMessage(rawMessage) || cleanedMessage.length > MAX_FRIENDLY_MESSAGE_LENGTH) {
            detail = fallbackForTechnicalError(rawMessage);
        } else {
            detail = truncateFriendlyMessage(cleanedMessage);
        }
    }

    return 'Lỗi render: ' + detail;
}

module.exports = {
    getUserFriendlyRenderError: getUserFriendlyRenderError,
    MAX_FRIENDLY_MESSAGE_LENGTH: MAX_FRIENDLY_MESSAGE_LENGTH
};



//////////////////
// WEBPACK FOOTER
// ../shared/utils/renderErrorMessage.js
// module id = fbTn
// module chunks = 31